export default __webpack_public_path__ + "static/Juliette-b33511a078b94676a7f6c9654a4be650.jpeg";